//
//
//
//
//
//
//
//
//
//

const COMPONENT_NAME = 'cube-slide-item'
export default {
  name: COMPONENT_NAME,
  props: {
    item: {
      type: Object,
      default() {
        /* istanbul ignore next */
        return {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/image-preview/src/slide/slide-item.vue